import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { FacilityTypes } from '../../types';
import { storeName as layoutModelStore } from '../models/layout.model';
import { getFacilityByKey } from '../../services/facility.service';
import { convertFacilitiesResponse, convertSimplifiedFacilityResponse } from '../../utils';

export const storeName = 'facilityEntity';

export const facilityEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saveSimplified: produce((state, entities) => {
      (entities || []).forEach((entity) => {
        const target = state.ids[entity.code] || {};
        state.ids[entity.code] = {
          ...target,
          ...entity,
          isSimplified: target?.isSimplified ?? true,
        };
      });
    }),
    saves: produce((state, entities: FacilityTypes[]) => {
      (entities || []).forEach((entity) => {
        state.ids[entity.code] = entity;
      });
    }),
  },

  effects: (dispatch: RematchDispatch<typeof facilityEntity>) => ({
    async loadByKey(payload: string, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const entities: FacilityTypes[] = state[storeName].ids;
      const item = entities[payload];
      if (item && !item.isSimplified) {
        return item;
      }
      const resp = await getFacilityByKey(payload, locale.apiLanguage);

      const facilities = [];
      const groupFacility = convertFacilitiesResponse(resp);
      facilities.push(groupFacility);

      if (resp && resp.children && resp.children.length) {
        const listFacility = resp.children.map((facility) => {
          return convertSimplifiedFacilityResponse(facility);
        });
        facilities.push(...listFacility);
      }
      this.saves(facilities);
      return groupFacility;
    },
  }),
});

export default facilityEntity;
